<template>
  <div>
    <div
      class="empty"
      v-if="listData.length === 0"
    >
      <img :src="imageError">
      <h6>此视频暂无文字识别信息</h6>
    </div>
    <el-timeline v-else>
      <el-timeline-item
        :timestamp="formateSeconds(item.startTime)"
        placement="top"
        v-for="(item, index) in listData"
        :key="index"
      >
        <ul
          :class="currentPlayIndex === index ? 'activeItem' : ''"
          @click="setPlay(index, item.startTime)"
        >
          <li
            v-for="(subItem, subItemIndex) in item.detailInfo"
            :key="subItemIndex"
          >
            {{ subItem.text }}
          </li>
        </ul>
      </el-timeline-item>
    </el-timeline>
  </div>
</template>

<script>
export default {
  name: 'TextRecognition',
  props: {
    detail: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      currentPlayIndex: null,
      imageError: require('@assets/imgs/jlxk/video-detail-error.png')
    }
  },
  computed: {
    listData() {
      return this.detail.ocr
    }
  },
  created() {},
  mounted() {},
  methods: {
    // 将秒转化为时分秒
    formateSeconds(endTime) {
      let secondTime = parseInt(endTime) // 将传入的秒的值转化为Number
      let min = 0 // 初始化分
      let h = 0 // 初始化小时
      let result = ''
      if (secondTime > 60) {
        // 如果秒数大于60，将秒数转换成整数
        min = parseInt(secondTime / 60) // 获取分钟，除以60取整数，得到整数分钟
        secondTime = parseInt(secondTime % 60) // 获取秒数，秒数取佘，得到整数秒数
        if (min > 60) {
          // 如果分钟大于60，将分钟转换成小时
          h = parseInt(min / 60) // 获取小时，获取分钟除以60，得到整数小时
          min = parseInt(min % 60) // 获取小时后取佘的分，获取分钟除以60取佘的分
        }
      }
      result = `${h.toString().padStart(2, '0')}:${min
        .toString()
        .padStart(2, '0')}:${secondTime.toString().padStart(2, '0')}`
      return result
    },
    setPlay(index, time) {
      this.currentPlayIndex = index
      this.$emit('handlePlay', time)
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .el-timeline {
  max-height: calc(100vh - 150px);
  overflow-y: auto;
  &-item {
    &__content {
      ul {
        width: 502px;
        background: #f5f7f8;
        border-radius: 3px;
        padding: 11px 15px 9px;
        &.activeItem {
          background: #ebeff2;
          li {
            color: #4497ec;
          }
        }
        li {
          font-size: 12px;
          color: #666;
          line-height: 16px;
        }
      }
    }
  }
}
</style>
